import React from 'react';
import { Layout } from 'react-admin';
import { AdminMenu } from './AdminMenu';

export const AdminLayout = (props) => <Layout {...props} menu={AdminMenu} />;
